import { MonitoringTypes } from '../Tasks/constants';
import FilterComponent from '../../components/FilterComponent';

export const NOTIFICATION_REDUCER_KEY = 'notifications';

export const NOTIFICATION_REDIRECTION_PATH = {
  [MonitoringTypes.VITALS]: "/user/monitoring",
  [MonitoringTypes.BATTERY]: "/user/monitoring",
  [MonitoringTypes.SOS]: "/user/location",
  [MonitoringTypes.ALARMS]: "/user/location",
  default: "/user/monitoring"
};

const { FilterDefinition, FilterDefinitionTypes } = FilterComponent;

const NotificationNameFilter = new FilterDefinition(FilterDefinitionTypes.VALUE, '', 'Notification Name', 'message');
const NotificationTypeFilter = new FilterDefinition(FilterDefinitionTypes.VALID_VALUES, '', 'Notification Type', 'type');
NotificationTypeFilter.validValues = [
  { value: 'NOTIFICATION', label: 'Notifications' },
  { value: 'ALARM', label: 'Alerts' },
];

export const NotificationFilters = [NotificationNameFilter, NotificationTypeFilter];

